// Hooks
import { useGetCurrUser } from 'hooks';
// Ui
import Image from 'ui/Image/Image';
import Text from 'ui3/Text/Text';
import LinkButton from 'ui3/LinkButton/LinkButton';
// Styles
import styles from './ProfileSection.module.scss';

const ProfileSection = () => {
  const { data } = useGetCurrUser();
  const user = data?.me;

  if (!user) {
    return null;
  }

  const storeName = user.slug ?? user.storeDetails?.storeName ?? '';
  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ');
  const avatarUrl = user.avatarUrl ?? user.storeDetails?.avatarURL ?? null;
  const linkUrl = `/${data?.me?.slug || ''}`;

  return (
    <div className={styles.root} data-testid="profile-section">
      <div className={styles.imageAndNameWrapper}>
        <div className={styles.avatarWrapper}>
          {avatarUrl ? (
            <Image
              src={avatarUrl}
              alt={fullName || 'Profile'}
              className={styles.avatar}
              sizes="64px"
              objectFit="cover"
              data-testid="profile-avatar"
            />
          ) : (
            <div
              className={styles.avatarPlaceholder}
              aria-hidden
              data-testid="profile-avatar-placeholder"
            />
          )}
        </div>
        {storeName && (
          <Text
            variant="subtitle3"
            color="lights-low"
            className={styles.storeName}
            data-testid="profile-store-name"
          >
            {storeName}
          </Text>
        )}
      </div>
      <div className={styles.info}>
        {fullName && (
          <Text
            variant="h6"
            color="lights-high"
            className={styles.fullName}
            data-testid="profile-full-name"
          >
            {fullName}
          </Text>
        )}
        <LinkButton
          link={linkUrl}
          subVariant="text"
          size="small"
          className={styles.viewProfileLink}
        >
          View profile
        </LinkButton>
      </div>
    </div>
  );
};

export default ProfileSection;
